import type { DrumPart, MusicNotes } from '../types';

export function hitsAt(positions: readonly number[], gain = 1): DrumPart['hits'] {
  return positions.map((position) => [position, gain]);
}

export function singles(pairs: readonly (readonly [step: number, degree: number])[]): MusicNotes {
  return pairs.map(([step, degree]) => [step, degree, 1]);
}
